import { Avatar, Backdrop, Button, Card, CardActions, CardContent, CardHeader, Container, Grid, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, TextField, Tooltip, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined';
import SendIcon from '@mui/icons-material/Send';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import avatar from 'src/assets/images/technician.png';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';


const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  rootlist: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 550,
  }),
  rootlistsag: (theme) => ({
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 500,
  }),

  cardBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  table: {
    minWidth: 650,
  },
  content: {
    minHeight: 550,
  },
  chatSection: {
    width: '100%',
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  headBG: {
    backgroundColor: '#e0e0e0'
  },
  borderRight500: {
    borderRight: '1px solid #e0e0e0'
  },
  messageArea: {
    overflowY: 'auto'
  },
  button: (theme) => ({
    margin: theme.spacing(1),
  }),
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
};
function Chat() {
  const params = useParams();
  const [Kullanici, setKullanici] = useState([]);
  const [Yorum, setYorum] = useState([]);
  const [YorumDetay, setYorumDetay] = useState([]);
  const [KullaniciId, setKullaniciId] = useState(0);
  const [Loading, setLoading] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [FisNo, setFisNo] = useState('');
  const [YorumNot, setYorumNot] = useState('');
  const SessionUser = getUser();
  const handleChangeKullanici = (param) => {
    setKullaniciId(param);
    setLoading(true);
    axios.get(`/GetYsAmbarYorum/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${param}`)
      .then(response => {
        if (response.data.length > 0) {
          setYorum(response.data);
        }
        setLoading(false);
      });

  }
  const GetYorumKullanici = () => {
    axios.get(`/GetDepoYorumKullanici/${0}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`)
      .then(response => {
        if (response.data.length > 0) {
          setKullanici(response.data);
        }
      });
  }
  const YorumDetayGoster = (FIS_NO) => {
    setFisNo(FIS_NO);
    setLoading(true);
    axios.get(`/GetYsAmbarYorumDetay/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${FIS_NO}`)
      .then(response => {
        if (response.data.length > 0) {
          setYorumDetay(response.data);
        }
        setLoading(false);
      });

  }
  const YorumDetayGonder = () => {
    setLoading(true);
    var FisParam = 0;
    if (FisNo !== '') {
      FisParam = FisNo;
    }
    axios.get(`/SetYsAmbarYorumDetay/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${FisParam}/${SessionUser.OrganizationUserId}/${KullaniciId}/${YorumNot}`)
      .then(response => {
        YorumDetayGoster(response.data[0].ErrorDescription);
        setLoading(false);
        setYorumNot("");
      });

  }
  useEffect(() => {
    let mounted = true;
    GetYorumKullanici();
    return () => {
      mounted = false;
    };
  }, [SessionUser.ServiceShopId, SessionUser.TechnicianId]);


  return (
    <Page sx={styles.root} title="Mesajlaşma">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Mesajlaşma" />
          <Divider />
          <CardContent>
            <Backdrop sx={styles.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={1}>
              <Grid
                size={{
                  xs: 12,
                  sm: 3
                }}>
                <Card sx={styles.cardBolum}>
                  <List>
                    <ListItem key="Kullanici">
                      <ListItemIcon>
                        <Avatar
                          alt="Person"
                          sx={styles.avatar}
                          src={avatar}
                        />
                      </ListItemIcon>
                      <ListItemText primary={SessionUser.FirstName + ' ' + SessionUser.LastName}></ListItemText>
                    </ListItem>
                  </List>
                  <Divider />
                  <Grid style={{ padding: '10px' }} size={12}>
                    <Autocomplete
                      id="Belirli bir kişi varsa seçiniz!..."
                      fullWidth
                      options={Kullanici}
                      sx={styles.option}
                      autoHighlight
                      onChange={(event, newValue) => {
                        if (newValue === null) {
                          return;
                        }
                        handleChangeKullanici(newValue.ID);
                      }}
                      getOptionLabel={(option) => option.ADSOYAD}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Belirli bir kişi varsa seçiniz!..."
                          variant="outlined"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />



                  </Grid>
                  <Divider />
                  <List sx={styles.rootlist}>
                    {Yorum
                      .map((row, index) => {
                        return (
                          <div>
                            <ListItem alignItems="flex-start">
                              <ListItemText
                                primary={row.FIS_NO + ' - ' + row.SAAT}
                                secondary={
                                  <React.Fragment>
                                    <Typography
                                      component="span"
                                      variant="body2"
                                      sx={styles.inline}
                                      color="textPrimary"
                                    >
                                      {row.TARIH}
                                    </Typography>
                                    {" — " + row.YORUM}
                                  </React.Fragment>
                                }
                              />
                              <ListItemSecondaryAction>
                                <Tooltip title="Detayları Göster">
                                  <IconButton
                                    color="primary"
                                    edge="end"
                                    onClick={(event) => YorumDetayGoster(row.FIS_NO)}
                                    size="small">
                                    <ArrowForwardIcon />
                                  </IconButton>
                                </Tooltip>
                              </ListItemSecondaryAction>
                            </ListItem>
                            <Divider component="li" />
                          </div>
                        );
                      })}
                  </List>
                </Card>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 9
                }}>
                <Card sx={styles.cardBolum}>
                  <List>
                    <ListItem key="Kullanici">
                      <ListItemIcon>
                        <Avatar
                          alt="Person"
                          sx={styles.avatar}
                          src={avatar}
                        />
                      </ListItemIcon>
                      <ListItemText primary={FisNo}></ListItemText>
                    </ListItem>
                  </List>
                  <Divider />
                  <CardContent sx={styles.content}>
                    <List sx={styles.rootlistsag}>
                      {YorumDetay
                        .map((row, index) => {
                          return (
                            <ListItem key={row.SIRA_NO}>
                              <Grid container>
                                <Grid size={12}>
                                  <ListItemText align={row.KONUM} primary={row.YORUM}></ListItemText>
                                </Grid>
                                <Grid size={12}>
                                  <ListItemText align={row.KONUM} secondary={row.TARIH}></ListItemText>
                                </Grid>
                              </Grid>
                            </ListItem>
                          );
                        })}
                    </List>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    <Grid container>
                      <Grid size={11}>
                        <TextField id="outlined-basic-email"
                          onChange={e => { setYorumNot(e.target.value) }}
                          value={YorumNot}
                          variant="outlined" label="Mesaj yazınız..." fullWidth />
                      </Grid>
                      <Grid size={1}>
                        <Button
                          variant="contained"
                          sx={styles.button}
                          color="secondary"
                          endIcon={<SendIcon></SendIcon>}
                          onClick={(event) => YorumDetayGonder()}
                        >
                          Gönder
                  </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Page >
  );
}

export default Chat;
